import React, { useEffect } from 'react'
import { useFlags } from 'shared/components/common/FlagsProvider'
import BasePage from 'src/components/layouts/BasePage'
import DocumentTitle from 'src/components/common/DocumentTitle'
import { makeStyles } from '@material-ui/core'
import type { Theme } from '@material-ui/core/styles'
import { Redirect } from 'react-router-dom'
import SchedulingView from './SchedulingView'
import { useNavContext } from 'src/components/common/Header/SideNav'

const useStyles = makeStyles<Theme>((_theme) => ({
  section: {
    marginTop: 3
  }
}))

export default function Scheduling() {
  const { productionFlag } = useFlags()
  const classes = useStyles()
  const { setPageSubtitle, setPageChip } = useNavContext()

  useEffect(() => {
    setPageSubtitle('Production')
    setPageChip({ variant: 'beta' })

    return () => {
      setPageSubtitle('')
      setPageChip(undefined)
    }
  }, [])
  return (
    <BasePage width={'xl'}>
      <DocumentTitle title="Scheduling" />
      {productionFlag ? (
        <div className={classes.section}>
          <SchedulingView />
        </div>
      ) : (
        <Redirect to="/" />
      )}
    </BasePage>
  )
}
